import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "add-todo" }
const _hoisted_2 = { class: "text-input text-input--focus" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isFormVisible)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "add-todo__form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addTodo && _ctx.addTodo(...args)), ["prevent"]))
        }, [
          _createElementVNode("button", {
            class: "close-button",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "bi bi-x" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.todoText) = $event)),
              class: "input"
            }, null, 512), [
              [_vModelText, _ctx.todoText]
            ])
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("button", { class: "button button--filled" }, "Add task", -1))
        ], 32))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "add-todo__show-form-button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showForm && _ctx.showForm(...args)))
        }, _cache[6] || (_cache[6] = [
          _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
        ])))
  ]))
}